import { PaymentData } from './PaymentData';
import { NetworkCoverage } from './NetworkCoverage';
import { Discount, Option, Subscription, GeneralUser, ISubscriptionRequest, IRecipientInfo, ItemConfig } from '@co-assist/library';
import { ISubscriptionGeneralUser } from '@co-assist/library/lib/model/subscriptionBundle.model';

export class SubscriptionBundle implements ISubscriptionRequest {
    helper?: SubscriptionGeneralUser;
    helped: SubscriptionGeneralUser;
    subscription: Subscription;
    discount?: Discount;
    itemConfig: ItemConfig;
    recipientInformation: SubscriptionRecipientInfo;
    paymentData: PaymentData;
    taxCredit: boolean;
    additionalInfo: string;
    coverage: NetworkCoverage;
    options: Option[];

    constructor(obj?: any) {
        this.helper = obj?.helper;
        this.helped = obj?.helped;
        this.subscription = obj?.subscription ? new Subscription(obj.subscription) : undefined;
        this.discount = obj?.discount ? new Discount(obj.discount) : undefined;
        this.itemConfig = obj?.itemConfig || new ItemConfig();
        this.recipientInformation = obj?.recipientInformation || new SubscriptionRecipientInfo();
        this.paymentData = obj?.additionalData || new PaymentData();
        this.taxCredit = obj?.taxCredit || false;
        this.additionalInfo = obj?.additionalInfo || '';
        this.coverage = obj?.coverage || new NetworkCoverage();
        this.options = obj?.options?.map(opt => new Option(opt)) || [];
    }
}

export class SubscriptionGeneralUser extends GeneralUser implements ISubscriptionGeneralUser {
    firstName: string;
    lastName: string;
    password?: string;

    constructor(object: any) {
        super(object);
        this.firstName = object.firstName;
        this.lastName = object.lastName
        this.password = object.password;
    }
}

export class SubscriptionRecipientInfo implements IRecipientInfo {
    recipientFirstName: string;
    recipientLastName: string;
    recipientAddress: string;

    constructor(object: any = {}) {
        this.recipientFirstName = object?.recipientFirstName || null;
        this.recipientLastName = object?.recipientLastName || null;
        this.recipientAddress = object?.recipientAddress || null;
    }
}
